import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";
import { Ref } from "react";

import { StoreDirectionsInput } from "./components/input/storeDirectionsInput.container";
import { StoreDirectionsMap } from "./components/map/storeDirectionsMap.container";
import { StoreDirectionsResult } from "./components/result/storeDirectionsResult.container";
import { useStoreDirectionsContext } from "./storeDirections.context";

type StoreDirectionsComponentProps = {
    ref: Ref<HTMLDivElement>;
};

export const StoreDirectionsComponent = ({
    ref
}: StoreDirectionsComponentProps) => {
    const { origin } = useStoreDirectionsContext();

    return (
        <div
            className={cn(
                "tw:h-[60vh] tw:max-h-125 tw:relative tw:rounded-md tw:bg-grey"
            )}
        >
            <StoreDirectionsMap ref={ref} />
            <div
                className={cn(
                    "tw:absolute tw:top-4 tw:left-4 tw:w-[calc(100%-2rem)] tw:max-w-100 tw:bg-white tw:rounded-md tw:p-4 tw:shadow"
                )}
            >
                {!isDefined(origin) && <StoreDirectionsInput />}
                {isDefined(origin) && <StoreDirectionsResult />}
            </div>
        </div>
    );
};
